import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { useRequest } from "redux-query-react";
import { ExportDataExcelHistoryFromJSON, getExportDataExcelHistory } from "api/ux/src";
export const useGetExportDataExcelHistory = (exportType) => {
    const requestParameters = {
        entityKind: exportType
    };
    const queryConfig = {
        force: true,
        transform: (body) => {
            const response = body.map(ExportDataExcelHistoryFromJSON);
            return { ExportDataExcelHistories: { [exportType]: response } };
        },
        update: {
            ExportDataExcelHistories: (prevValue, transformedValue) => ({ ...prevValue, ...transformedValue })
        }
    };
    const request = useRequest(getExportDataExcelHistory(requestParameters, queryConfig));
    return request;
};
export const useExportDataExcelHistory = (exportType) => useSelector((state) => state.entities.ExportDataExcelHistories[exportType] ?? [], isEqual);
